module.exports = __webpack_public_path__ + "static/wheelchair-access-sm-5d5b7730f6c847a41d4d1b4b1a974752.jpg";